<span class="HygieneInspectionStatus">
  <mat-icon
    fontSet="material-symbols-outlined"
    *ngIf="inspection.hygieneData"
    matTooltip="{{
      'inspections.statusHygiene.' + inspection.hygieneData.status + '.text'
        | enum
    }}"
    >{{
      'inspections.statusHygiene.' + inspection.hygieneData.status + '.icon'
        | enum
    }}</mat-icon
  >
  <span>
    {{
      inspection.hygieneData !== null
        ? ('inspections.statusHygiene.' +
            inspection.hygieneData!.status +
            '.text' | enum)
        : ('inspections.statusHygiene.default' | enum)
    }}
  </span>
</span>
